
export default function News() {
  const handleViewAll = () => {
    window.REACT_APP_NAVIGATE('/blog');
  };

  return (
    <section id="news" className="py-24 lg:py-32 bg-[#F5E6D3]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-16 gap-6">
          <div>
            <div className="w-16 h-1 bg-[#D4A574] mb-4"></div>
            <h2 className="text-5xl lg:text-6xl font-bold text-[#2C1810] font-['Space_Mono'] tracking-tight">
              FROM OUR BLOG
            </h2>
          </div>
          <button 
            onClick={handleViewAll}
            className="px-8 py-3 border-4 border-[#2C1810] bg-[#2C1810] text-[#F5E6D3] font-bold font-['Space_Mono'] hover:bg-transparent hover:text-[#2C1810] transition-all whitespace-nowrap cursor-pointer text-sm tracking-wide"
          >
            VIEW ALL POSTS
          </button>
        </div>

        <div className="flex items-center justify-center py-20">
          <p className="text-2xl text-[#5C4033] font-['DM_Sans']">
            No blog posts yet. Check back soon for updates!
          </p>
        </div>
      </div>
    </section>
  );
}
